import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Teacher, TeacherState } from '../types/teacher';

const initialState: TeacherState = {
  teachers: [],
  loading: false,
  error: null,
};

const teacherSlice = createSlice({
  name: 'teachers',
  initialState,
  reducers: {
    fetchteachersStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchteachersSuccess: (state, action: PayloadAction<Teacher[]>) => {
      state.loading = false;
      state.teachers = action.payload;
    },
    fetchteachersFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    addteacherStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    addteacherSuccess: (state, action: PayloadAction<Teacher>) => {
      state.loading = false;
      state.teachers.push(action.payload);
    },
    addteacherFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateteacherStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateteacherSuccess: (state, action: PayloadAction<Teacher>) => {
      state.loading = false;
      state.teachers = state.teachers.map((teacher) =>
        teacher.id === action.payload.id ? action.payload : teacher
      );
    },
    updateteacherFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    deleteteacherStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteteacherSuccess: (state, action: PayloadAction<number>) => {
      state.loading = false;
      state.teachers = state.teachers.filter((teacher) => teacher.id !== action.payload);
    },
    deleteteacherFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    // No extra reducers needed since we are not using createAsyncThunk
  },
});

export const {
  fetchteachersStart,
  fetchteachersSuccess,
  fetchteachersFailure,
  addteacherStart,
  addteacherSuccess,
  addteacherFailure,
  updateteacherStart,
  updateteacherSuccess,
  updateteacherFailure,
  deleteteacherStart,
  deleteteacherSuccess,
  deleteteacherFailure,
} = teacherSlice.actions;

export default teacherSlice.reducer;